"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const immer_1 = require("immer");
const command_1 = require("../type/command");
const updateAccessDates_1 = require("./updateAccessDates");
const updateCompletionStatus_1 = require("./updateCompletionStatus");
const updateProgressMeasure_1 = require("./updateProgressMeasure");
const updateSubmissionCount_1 = require("./updateSubmissionCount");
const updateSuccessStatus_1 = require("./updateSuccessStatus");
const updateTimeSpent_1 = require("./updateTimeSpent");
const updateUnitsCompletedCount_1 = require("./updateUnitsCompletedCount");
function evaluateCurriculum(command, user, content, states) {
    const events = [];
    const resetProgressFlag = command.type === command_1.CommandType.RESET_PROGRESS ? true : false;
    const updatedStates = immer_1.produce(states, draftStates => {
        const progressMeasureEvents = updateProgressMeasure_1.updateProgressMeasure(command, user, content, draftStates, resetProgressFlag);
        updateSubmissionCount_1.updateSubmissionCount(command, user, content, draftStates);
        updateUnitsCompletedCount_1.updateUnitsCompletedCount(command, user, content, draftStates);
        const completionStatusEvents = updateCompletionStatus_1.updateCompletionStatus(command, user, content, draftStates, resetProgressFlag);
        const successStatusEvents = updateSuccessStatus_1.updateSuccessStatus(command, user, content, draftStates);
        const timeSpentEvents = updateTimeSpent_1.updateTimeSpent(command, user, content, draftStates);
        const accessDatesEvents = updateAccessDates_1.updateAccessDates(command, user, content, draftStates);
        events.push(...progressMeasureEvents, ...completionStatusEvents, ...successStatusEvents, ...timeSpentEvents, ...accessDatesEvents);
    });
    return { events, states: updatedStates, stateInteractions: [] };
}
exports.evaluateCurriculum = evaluateCurriculum;
//# sourceMappingURL=evaluateCurriculum.js.map